import { Locale } from '@core/Entities/Locale/Locale.entity';
import { Filter } from '@core/Entities/Search/SearchFilters/Filter.entity';
import { mapFiltersForDisplay } from '@core/Utils/SearchFilters/MapFiltersForDisplay';

export function generateFiltersForDisplay(filters: Filter[], locale: Locale) {
  const mappedFilters = mapFiltersForDisplay(filters, locale);

  const regionFilter = mappedFilters.find(filter => filter.id === 'region');
  const dealershipFilter = mappedFilters.find(filter => filter.id === 'dealership-id');

  if ((regionFilter && regionFilter.value) || (dealershipFilter && dealershipFilter.value)) {
    // If region is defined, remove postcode and max-distance filters
    const filteredFilters = mappedFilters.filter(
      filter => filter.id !== 'postcode' && filter.id !== 'max-distance',
    );
    return filteredFilters;
  }

  return mappedFilters;
}
